import {
    getAlternateLanguageUrls,
    getCurrentPage,
    getFooter,
    getHeader,
    getLocation,
    getLocationPathAndQuery,
    getPageStateByPath,
    getPageStateByType,
    getRequiresAuthorization,
    getReturnUrl,
} from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import convertSelectorToHook from "@store/Framework/Common/Utilities/convertSelectorToHook";

export const useCurrentPage = convertSelectorToHook(getCurrentPage);
export const usePageStateByPath = convertSelectorToHook(getPageStateByPath);
export const useRequiresAuthorization = convertSelectorToHook(getRequiresAuthorization);
export const useAlternateLanguageUrls = convertSelectorToHook(getAlternateLanguageUrls);
export const useFooterPage = convertSelectorToHook(getFooter);
export const useHeaderPage = convertSelectorToHook(getHeader);
export const useLocation = convertSelectorToHook(getLocation);
export const useLocationPathAndQuery = convertSelectorToHook(getLocationPathAndQuery);
export const usePageStateByType = convertSelectorToHook(getPageStateByType);
export const useReturnUrl = convertSelectorToHook(getReturnUrl);
